import {AuwBaseComponent} from "EXT/auw_config/Resources/Private/Js/AuwBaseComponent";
import "regenerator-runtime/runtime";

export class AuwMemolist extends AuwBaseComponent {
  constructor($el) {
    super($el);
  }

  __PageReady() {

    document.addEventListener('click', async evt => {
      /**
       * Whenever the document is clicked, check whether the target has class `js-ex_auwmemolist`. If it does, some
       * ajax calls need to be made. If it does not, then some UI changes might be necessary.
       */
      const target = evt.target.closest('.js-tx_auwmemolist');

      if (target) {
        // Prevent default behavior
        evt.preventDefault()
        // Get the containing div with class `teaser_memolist`. This will be removed by whatever our ajax calls return.
        const container = evt.target.closest('.teaser__memolist')
        const containerParent = container.parentNode
        // Make the ajax call and store the resulting html.
        const rawResult = await fetch(target.href)
        const textContent = await rawResult.text()
        const domParser = new DOMParser()
        const html = domParser.parseFromString(textContent, 'text/html')

        // Place each node from the returned html right before the container. Usually this will be just one div.
        html.body.childNodes.forEach(node => {
          if(node.nodeType !== Node.ELEMENT_NODE || node.classList.contains('teaser__memolist-linklist')) {
          } else {
            containerParent.insertBefore(node, container);

            //if login opens --> reset z-index on all .teaser__memolist
            if(node.classList.contains('memolist__login')) {
              $('.teaser__memolist').addClass('resetZindex');
            }
          }
        });
        // Remove the old container
        container.remove();
        // If a link to the user's memolist was added, it needs to be shown for five seconds.
        const showListLink = containerParent.querySelector('.teaser__memolist-linklist');
        if(showListLink) {
          showListLink.classList.add("show");
          setTimeout(function() {
            showListLink.classList.remove("show");
          }, 5500);
        }
      } else {
        // If some other element was clicked, we might have to show or hide the login form.
        const targetLoginOpenBtn = evt.target.closest('.memolist__login-open');
        const targetLoginCloseBtn = evt.target.closest('.memolist__login-close');
        if(targetLoginCloseBtn) {
          targetLoginCloseBtn.closest('.memolist__login').style.display = 'none';
          $('.teaser__memolist').removeClass('resetZindex');
        } else if(targetLoginOpenBtn){
          targetLoginOpenBtn.nextElementSibling.style.display = 'block';
          $('.teaser__memolist').addClass('resetZindex');
        } else if(!this.targetInsideLoginPopUp(evt.target)){
          $('.memolist__login:visible').hide();
          $('.teaser__memolist').removeClass('resetZindex');
        }
      }
    })

    /**
     * Replace placeholders with the correct icon. This is done by finding all elements with the property
     * `data-memolist-ajax-uri`, make an ajax call to the url stored in that property, and replace the containing
     * element with whatever was returned by that ajax call.
     */
    const replacePlaceholder = async el => {
      try {
        const rawResult = await fetch(el.dataset.memolistAjaxUri)
        const textContent = await rawResult.text()
        const domParser = new DOMParser()
        const html = domParser.parseFromString(textContent, 'text/html')
        let container = null

        html.body.childNodes.forEach(node => {
          // Get the containing div with class `teaser_memolist`. This will be removed by whatever our ajax calls return.
          container = el.closest('.teaser__memolist')
          container?.parentNode?.insertBefore(node, container)
        })
        container?.remove()
      } catch (e) {
        if (el.nodeType === Node.ELEMENT_NODE) {
          el.removeAttribute('data-memolist-ajax-uri')
        }
        // console.log(el)
      }
    }

    document.querySelectorAll('[data-memolist-ajax-uri]').forEach(replacePlaceholder)
    const mutationObserver = new MutationObserver((mutationList, _) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(el => {
            if (el.nodeType === Node.ELEMENT_NODE) {
              el.querySelectorAll('[data-memolist-ajax-uri]').forEach(replacePlaceholder)
            }
          })
        }
      }
    })
    mutationObserver.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: false,
    })
  }

  targetInsideLoginPopUp(target){
    let loginPopUps = document.getElementsByClassName('memolist__login-content');
    for(let i = 0; i<loginPopUps.length; i++){
      if(loginPopUps[i].contains(target)){
        return true;
      }
    }
  }
}

if ($(".teaser__memolist").length) {
    new AuwMemolist();
}
